module.exports = __webpack_public_path__ + "0d35f30fd5dafb7e08e2788fe7fcd79f.png";